import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";

export default function BillingInfoModel(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Dialog
        className="user-filter-popup billinginfo-popup"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={props.open}
        aria-labelledby="responsive-dialog-title"
      >
        <Box sx={{ p: "22px 34px 0px 34px" }}>
          <Typography className="billing-info-title">
            1. Select a Project
          </Typography>
          <Typography className="billing-info-text">
            Only projects to which you are assigned will appear in this list.
          </Typography>
          <Typography sx={{ mt: "30px" }} className="billing-info-title">
            2. Select a Billing Period
          </Typography>
          <Typography className="billing-info-text">
            The billing periods displayed will depend on the billing period of
            the selected project. Select a billing period and if this project
            has a billing statement for that period then it will be displayed.
            If the project does not have a billing statement for the selected
            period then instructions will be displayed for how to creating a
            billing statement.
          </Typography>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "22px 34px", pt: "20px" }}
        >
          <Button sx={{ color: "#212121 !important" }} className="cancel-btn" 
          onClick={ ()=> {
            props.setBillingHelpButton(false)
          } }
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
